import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementCommon,
  Phone,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createCheckInFlight,
  createJourney,
  createJourneyTraveler,
  createMockData,
  createMockDataWithResponse,
  createName,
  MockJourneyTraveler,
  MockName,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  travelerPaxType,
} from '../../mock';
import {
  etktAndFFBoardingPassResult,
} from '../../mock/data';
import {
  globalDob,
} from '../../mock/dictionaries/dates';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const email: Email = {
  id: 'email-id',
  address: 'christophe.bernard@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const phone: Phone = {
  id: 'phone-id',
  number: '+33123456789',
  category: 'personal',
  contactType: 'Phone',
  purpose: 'information'
};
export const travelerName: MockName = createName({
  template: {
    firstName: 'TEST',
    lastName: 'BERNARD',
    title: 'Mr'
  }
});
const namedTraveler: MockJourneyTraveler = createJourneyTraveler({
  template: {
    names: [travelerName],
    passengerTypeCode: travelerPaxType,
    gender: 'male',
    dateOfBirth: new utils.Date(globalDob)
  }
});
const mockFlight1 = createCheckInFlight({
  template: {
    id: 'CHECK-IN-FLIGHT-0-MOCK',
    departure: {
      locationCode: 'NCE'
    },
    arrival: {
      locationCode: 'LHR'
    },
    acceptanceStatus: 'opened'
  }
});

const journeyTemplate: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};
/* const journey = createJourney({ template: {
  type: 'standalone',
  travelers: combineJourneyTravelers([
    JourneyTravelerRepository.MAN]).items,
  flights: combineCheckInFlightIdObjects([
    CheckInFlightIdObjectRepository.FRA_NCE]).items,
  id: 'JOURNEY-0-MOCK',
  journeyElements: combineJourneyElementCommons([
    {journeyElement: {traveler: {id: 'JOURNEY-TRAVELER-0-MOCK'}}}]).items,
  acceptance: {
    isAccepted: false,
    isPartial: false
  }
}});*/

/* const partialAcceptedjourney = createJourney({ template: {
  ...journey,
  // journeyElements: combineJourneyElementCommons([{journeyElement: {traveler: {id: 'JOURNEY-TRAVELER-0-MOCK'}, checkInStatus: 'notAccepted'}}]).items,
  acceptance: createAcceptance({
    template: {
      notCheckedInJourneyElements: [
        {id: 'JOURNEY-ELEMENT-0-MOCK', journeyElement: createJourneyElement()}
      ],
      isAccepted: false,
      isPartial: false
    }
  })
}});*/

const journeys = combineJourneys([journeyTemplate]).items;
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));
/**
 * OW 1Journey
 * 1ADT
 * No baggage
 */
export const ow1Journey1AdtCancelCheckIn: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(etktAndFFBoardingPassResult, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201), createMockDataWithResponse([{
    ...journeys[0],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ), createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: {
            isAccepted: false,
            isPartial: false,
            isVoluntaryDeniedBoarding: false,
            notCheckedInJourneyElements: [
              {
                id: 'JOURNEY-ELEMENT-0-MOCK',
                journeyElement: {
                  id: 'JOURNEY-ELEMENT-0-MOCK',
                  travelerId: 'JOURNEY-TRAVELER-0-MOCK',
                  flightId: 'CHECK-IN-FLIGHT-0-MOCK',
                  acceptanceEligibility: {
                    status: 'eligible',
                    reasons: []
                  },
                  checkInStatus: 'notAccepted',
                  boardingPassEligibility: {
                    status: 'ineligible'
                  },
                  traveler: namedTraveler,
                  flight: mockFlight1
                }
              }
            ]
          }
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  deleteAcceptanceFromJourney: [createMockDataWithResponse({}, 204)]
};
